import { render, staticRenderFns } from "./igt-combat-feature.vue?vue&type=template&id=5a62b0c3&scoped=true&"
import script from "./igt-combat-feature.vue?vue&type=script&lang=js&"
export * from "./igt-combat-feature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a62b0c3",
  null
  
)

export default component.exports